<template>
  <div id="loading_bar" class="w-48">
    <progress-bar :val="percentage" bar-color="#fff" bg-color="#000"></progress-bar>
    <p class="text-center text-white font-bold text-lg mt-4">{{ percentage }}%</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProgressBar from "vue-simple-progress";

export default {
  data() {
    return {
      percentage: 0,
      stepValue: 0,
    };
  },
  components: {
    ProgressBar,
  },
  computed: {
    ...mapGetters({
      itemsToLoad: "loader/itemsToLoad",
      itemsLoaded: "loader/itemsLoaded",
    }),
  },
  mounted() {
    this.stepValue = 100 / this.itemsToLoad;
  },
  watch: {
    itemsLoaded(newValue) {
      if (this.stepValue * newValue > 100) return;
      this.percentage = this.stepValue * newValue;
    },
  },
};
</script>

<style>
</style>